import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { MButton } from '@/components/ui/atoms/MButtons';
import MTopBar from '@/components/ui/atoms/MTopBar';
import MFrame from '@/components/ui/atoms/MFrame';
import { IconDatabase, IconShieldLock, IconKey } from '@tabler/icons-react';
import styles from './OnboardingInfo.module.css';

const OnboardingInfo = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();

  const isLogin = location.state?.isLogin || false;

  const handleContinue = () => {
    if (isLogin) {
      // For login, go to login form with mobile as default
      navigate('/login/form', { state: { mode: 'mobile', isLogin: true } });
    } else {
      // For signup flow, go to consent page
      navigate('/register/consent');
    }
  };

  const benefits = [
    {
      icon: IconDatabase,
      text: t('auth.onboarding.info.benefit1')
    },
    {
      icon: IconShieldLock,
      text: t('auth.onboarding.info.benefit2')
    },
    {
      icon: IconKey,
      text: t('auth.onboarding.info.benefit3')
    }
  ];

  return (
    <div className={styles.onboardingPage}>
      {/* Top Bar with Back and Exit */}
      <MTopBar
        onBack={() => navigate(-1)}
        exitPath="/"
        exitKey="exit"
        withBackground={false}
        hideProfilePicker
      />

      {/* Content */}
      <div className={styles.content}>
        <h1 className={styles.title}>
          {t('auth.onboarding.info.title').split('\n').map((line, i) => (
            <span key={i}>
              {line}
              {i < t('auth.onboarding.info.title').split('\n').length - 1 && <br />}
            </span>
          ))}
        </h1>

        <MFrame className={styles.benefitsCard}>
          {benefits.map((benefit, index) => {
            const Icon = benefit.icon;
            return (
              <div key={index} className={styles.benefitItem}>
                <div className={styles.iconCircle}>
                  <Icon size={24} color="#6D28D9" />
                </div>
                <p className={styles.benefitText}>
                  {benefit.text.split('\n').map((line, i) => (
                    <span key={i}>
                      {line}
                      {i < benefit.text.split('\n').length - 1 && <br />}
                    </span>
                  ))}
                </p>
              </div>
            );
          })}
        </MFrame>

        <p className={styles.trialText}>
          {t('auth.onboarding.info.trialText').split('\n').map((line, i) => (
            <span key={i}>
              {line}
              {i < t('auth.onboarding.info.trialText').split('\n').length - 1 && <br />}
            </span>
          ))}
        </p>
        <div className={styles.footer}>
          <MButton
            variant="filled"
            size="lg"
            onClick={handleContinue}
            className={styles.continueButton}
          >
            {t('auth.onboarding.info.continue')}
          </MButton>
        </div>
      </div>

    </div>
  );
};

export default OnboardingInfo;
